import * as React from 'react';

export interface TicketFeedProps {
  users: {};
  typingUsers: {};
}

export const TicketFeed = ({ users, typingUsers }:TicketFeedProps) => {
  interface User {
    id: string,
    name: string,
    username: string,
  }

  const [visible, setVisible] = React.useState(false);
  const viewingUsersValues = Object.values(users);
  const typingUsersValues = Object.values(typingUsers);
  const viewerCountElement = () => {
    if (viewingUsersValues.length === 0) <></>;
    return (
      <>
        {viewingUsersValues.length}
        &nbsp;
        {viewingUsersValues.length === 1 ? 'user' : 'users'}
        &nbsp;viewing
      </>
    );
  };

  const ticketViewersElement = () => {
    if (viewingUsersValues.length > 0) {
      const viewers = viewingUsersValues.map((user: User) => <div className="user" key={user.id}>{user.name ? user.name : 'no-name'}</div>);
      return <>{viewers}</>;
    }
    return <></>;
  };

  const showViewers = () => setVisible(true);
  const hideViewers = () => setVisible(false);
  const ticketTypingClassName = typingUsersValues.length > 0 ? 'ticket-typing' : 'ticket-typing hide';
  const ticketViewerClassName = visible ? 'ticket-viewers noselect' : 'ticket-viewers noselect hide';
  const ticketViewerCountClassName = viewingUsersValues.length > 0 ? 'ticket-viewer-count noselect' : 'ticket-viewer-count noselect hide';
  return (
    <div className="ticket-feed">
      <div className={ticketTypingClassName}>
        <div className="dots">
          <span className="dot" />
          <span className="dot" />
          <span className="dot" />
        </div>
        <div className="names">
          <b>{typingUsersValues.map((user: User) => user.name).join(', ')}</b>
          &nbsp;
          {typingUsersValues.length === 1 ? 'is' : 'are'}
          &nbsp;typing
        </div>
      </div>
      <div
        className={ticketViewerCountClassName}
        onFocus={showViewers}
        onMouseOver={showViewers}
        onTouchStart={showViewers}
        onTouchEnd={hideViewers}
        onMouseLeave={hideViewers}
      >
        {viewerCountElement()}
      </div>
      <div className={ticketViewerClassName}>
        <h4>Users Viewing Ticket</h4>
        {ticketViewersElement()}
      </div>
    </div>
  );
};
